export const BrandLogo = ({ size = 40, showText = true, textClass = "text-lg", testId = "brand-logo" }) => (
  <div className="flex items-center gap-3" data-testid={testId}>
    <div className="brand-badge shrink-0" style={{ width: size, height: size }}>
      <img src="/logo.png" alt="Méca Pièces PRO" />
    </div>
    {showText && (
      <div className={`font-heading font-black uppercase leading-none tracking-tight ${textClass}`}>
        <span className="text-metal">Méca Pièces</span> <span className="text-brand-red italic">Pro</span>
      </div>
    )}
  </div>
);
